import { useQuery } from '@tanstack/react-query';

import { fetchTeamActionsInfo } from '@/api/v4/team-actions-info';
import { QueryKey } from '@/config/query-client';

import { teamIdState } from '../../team.state';
import { useAtomValue } from 'jotai';

export const useTeamActionsInfo = () => {
  const teamId = useAtomValue(teamIdState);

  const fetchActionsInfo = async () => {
    if (!teamId) return;

    return fetchTeamActionsInfo(teamId);
  };

  return useQuery({
    queryKey: [QueryKey.TeamActionsInfo, teamId],
    queryFn: fetchActionsInfo,
    enabled: !!teamId,
    staleTime: 1000 * 60 * 5,
  });
};
